import React, { Component } from "react";
import { ButtonToolbar, Table, Grid } from 'react-bootstrap';

import { LoadingSpinner } from '../../LoadingSpinner';
import { SortIndicator } from '../../SortIndicator';
import { PaginationBuilder } from '../../PaginationBuilder';
import { SearchHelper } from '../../helpers/SearchHelper';
import { ComparisonHelper } from '../../helpers/ComparisonHelper';
import { PaginationHelper } from '../../helpers/PaginationHelper';
import { TableButton } from '../../TableButton';

export class StopsActive extends Component {
    constructor(props) {
        super(props);

        this.state = {
            render: {
                sort: {
                    property: "code",
                    type: "ascending"
                }
            }
        }
    }

    // -----------------------

    getStopLines(stops) {
        const stop = stops.find(s => s.lines === undefined);

        if (undefined !== stop) {
            this.props.getStopLines(stop);
            stop.lines = [];
        }
    }

    getStopMunicipality(stops) {
        const stop = stops.find(s => s.lines === undefined);

        if (undefined !== stop) {
            this.props.getStopMunicipality(stop);
            stop.municipality = [];
        }
    }

    // -----------------------

    onChangeSort(property) {
        const { render } = this.state;

        render.sort.type = render.sort.property === property && "ascending" === render.sort.type ? "descending" : "ascending";
        render.sort.property = property;

        this.setState({
            render: render
        });
    }

    // -----------------------

    filterByInfo(value) {
        return value.map(v => v).join();
    }

    sortStops(sort, a, b) {
        let aValue = a[sort.property];
        let bValue = b[sort.property];

        if ("object" === typeof aValue) {
            aValue = undefined !== aValue.left ? aValue.left : aValue.right;
        }

        if ("object" === typeof bValue) {
            bValue = undefined !== bValue.left ? bValue.left : bValue.right;
        }

        if(undefined === aValue) {
            aValue = "";
        }

        if(undefined === bValue) {
            bValue = "";
        }

        if (aValue === bValue) {
            return 0;
        }

        const output = aValue < bValue ? -1 : 1;
        if ("descending" === sort.type) {
            return output * -1;
        }

        return output;
    }

    // -----------------------

    renderLoading(isLoading) {
        if (isLoading) {
            return (
                <LoadingSpinner />
            );
        }

        return null;
    }

    renderSortIndicator(property, sort) {
        if (property !== sort.property) {
            return (
                <SortIndicator order="none" />
            );
        }

        return (
            <SortIndicator order={sort.type} />
        );
    }

    renderIsActiveLabel(isActive) {
        return isActive ? "Sim" : "Não";
    }

    renderStopInfo(stopInfo, index) {
        return stopInfo !== undefined ? stopInfo.map((info, i) => <li key={`stop-${index}-info-${i}`}>{info}</li>) : null;
    }

    renderStopLines(stopLines, index) {
        return stopLines !== undefined ? stopLines.map((line, i) => <li key={`stop-${index}-line-${i}`}>{line}</li>) : null;
    }

    renderMapPoint(mapPoint) {
        if(undefined === mapPoint) {
            return null;
        }

        return ComparisonHelper.renderProperty(mapPoint.name);
    }

    render() {
        const { render } = this.state;
        const { stops, isLoading, currentPage, elementsPerPage, isComparing, filter } = this.props;

        let stopsFiltered;
        if (isComparing) {
            const { draftStops } = this.props;

            stopsFiltered = SearchHelper.search({
                filter: filter,
                data: ComparisonHelper.compare(
                    stops,
                    draftStops,
                    {
                        match: [{ left: "code", right: "code" }],
                        fields: [{ left: "extCode", right: "externalCode" }, { left: "name", right: "name" }, { left: "latitude", right: "latitude" }, { left: "longitude", right: "longitude" }, {left: "info", right: "info"}]
                    }),
                fields: ["code", "code.left", "code.right", "name", "name.left", "name.right", "shortName", "extCode", "extCode.left", "extCode.right", "isActive", "isActive.left", "isActive.right", "latitude", "latitude.left", "latitude.right", "longitude", "longitude.left", "longitude.right", "mapPoint.name", "info"],
                valueParser: {
                    "isActive": {
                        "true": "sim",
                        "false": "não"
                    }
                },
                callbackComparison: [{ "info": (a) => this.filterByInfo(a) }]
            });
        }
        else {
            stopsFiltered = SearchHelper.search({
                filter: filter,
                data: stops,
                fields: ["code", "name", "shortName", "extCode", "isActive", "latitude", "longitude", "mapPoint.name", "info"],
                valueParser: {
                    "isActive": {
                        "true": "sim",
                        "false": "não"
                    }
                },
                callbackComparison: [{ "info": (a) => this.filterByInfo(a) }]
            });
        }

        const totalPages = PaginationHelper.getTotalPages(stopsFiltered.length, elementsPerPage);
        const activePage = totalPages < currentPage ? totalPages : currentPage;
        const stopsToRender = stopsFiltered.sort((a, b) => this.sortStops(render.sort, a, b))
            .slice((activePage - 1) * elementsPerPage, activePage * elementsPerPage);

        this.getStopLines(stopsToRender);
        this.getStopMunicipality(stopsToRender);

        return (
            <Grid fluid className="table-small-screens">
                <div className="table-loading">
                    <Table responsive striped hover>
                        <thead>
                            <tr>
                                <th className="width-7p sortable" onClick={() => this.onChangeSort("code")}>Código {this.renderSortIndicator("code", render.sort)}</th>
                                <th className="width-11p sortable" onClick={() => this.onChangeSort("extCode")}>Código Externo {this.renderSortIndicator("extCode", render.sort)}</th>
                                <th className="width-15p sortable" onClick={() => this.onChangeSort("name")}>Nome {this.renderSortIndicator("name", render.sort)}</th>
                                <th className="width-10p sortable" onClick={() => this.onChangeSort("shortName")}>Abreviatura {this.renderSortIndicator("shortName", render.sort)}</th>
                                <th className="width-1p">Ativa</th>
                                <th className="width-8p sortable" onClick={() => this.onChangeSort("latitude")}>Latitude {this.renderSortIndicator("latitude", render.sort)}</th>
                                <th className="width-8p sortable" onClick={() => this.onChangeSort("longitude")}>Longitude {this.renderSortIndicator("longitude", render.sort)}</th>
                                <th className="width-8p">Ponto Notável</th>
                                <th className="width-7p">Mun.</th>
                                <th className="width-8p">Info. Adicional</th>
                                <th className="width-5p">Linhas</th>
                                <th className="width-7p">&nbsp;</th>
                            </tr>
                        </thead>
                        <tbody className={isLoading ? "overlay" : ""}>
                            {
                                stopsToRender.map((stop, idx) =>
                                    <tr key={`stop-${idx}`} className={ComparisonHelper.getRowClass(stop.code)}>
                                        <td>{ComparisonHelper.renderProperty(stop.code)}</td>
                                        <td>{ComparisonHelper.renderProperty(stop.extCode)}</td>
                                        <td>{ComparisonHelper.renderProperty(stop.name)}</td>
                                        <td>{ComparisonHelper.renderProperty(stop.shortName)}</td>
                                        <td>{ComparisonHelper.renderProperty(stop.isActive, (a) => this.renderIsActiveLabel(a))}</td>
                                        <td>{ComparisonHelper.renderProperty(stop.latitude)}</td>
                                        <td>{ComparisonHelper.renderProperty(stop.longitude)}</td>
                                        <td>{this.renderMapPoint(stop.mapPoint)}</td> 
                                        <td>{ComparisonHelper.renderProperty(stop.municipality)}</td>
                                        <td>{ComparisonHelper.renderProperty(stop.info, (a) => this.renderStopInfo(a, idx))}</td>
                                        <td>{ComparisonHelper.renderProperty(stop.lines, (a) => this.renderStopLines(a, idx))}</td>
                                        <td>
                                            <ButtonToolbar className="pull-right">
                                                <TableButton marginRight icon="icon-edit" title="Editar" onClick={() => this.props.onEditClick(stop)} />
                                                <TableButton icon="icon-trash" title="Eliminar" onClick={() => this.props.onDeleteClick(stop)} />
                                            </ButtonToolbar>
                                        </td>
                                    </tr>
                                )
                            }
                        </tbody>
                    </Table>

                    <PaginationBuilder
                        currentPage={activePage}
                        elementsPerPage={elementsPerPage}
                        dataLength={stopsFiltered.length}
                        onChangePage={(a) => this.props.onChangePage(a)}
                        onChangeElementsPerPage={(a) => this.props.onChangeElementsPerPage(a)} />

                    {this.renderLoading(isLoading)}
                </div>
            </Grid>
        );
    }
}



// WEBPACK FOOTER //
// ./src/components/datamanager/stops/StopsActive.js